import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';

import EntityPickerModal from '../modal/EntityPickerModal';
import docsPlugin from '../plugins/docs';

const CopyAttachmentsFromProjectFilesModal = ({
  open,
  onClose,
  onSave,
  isSaving,
  ...rest
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const customDocsPlugin = {
    ...docsPlugin,
    PickerModalTitle: () => T.translate('MODAL_ADD_ATTACHMENTS'),
    AddRelationshipsButtonText: () => T.translate('MODAL_ATTACH_A_COPY'),
  };

  return (
    <EntityPickerModal
      open={open}
      closeModal={onClose}
      plugin={customDocsPlugin}
      isSaving={isSaving}
      loading={false}
      error={false}
      allowCreate={false}
      multiple={true}
      onSave={onSave}
      {...rest}
    />
  );
};

CopyAttachmentsFromProjectFilesModal.propTypes = {
  open: PropTypes.bool,
  isSaving: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

export default CopyAttachmentsFromProjectFilesModal;
